import { SearchFiltersDropdown } from '../../components/search-filters-dropdown/search-filters-dropdown'
import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { withFilterContext } from '../hocs/filter.context.hoc'

export const AnnualTax = withFacetContext(
    FacetName.annual_tax_values,
    withFilterContext(FilterName.annual_tax_values, SearchFiltersDropdown, {
        title: 'Annual tax',
        hideLabel: true,
    })
)
